// extracted by mini-css-extract-plugin
module.exports = {"confetti":"Celebration_confetti__3CHVz"};